import React, { useEffect, useState } from 'react';
import type { LegalBlock } from '../models/ast';
import { paginate, type PageSetup } from '../engine/LegalLayoutEngine';

const SETUP: PageSetup = {
  pageWidthPx: 816,
  pageHeightPx: 1056,
  marginTopPx: 72,
  marginRightPx: 72,
  marginBottomPx: 72,
  marginLeftPx: 72,
  headerHeightPx: 24,
  footerHeightPx: 36,
};

export default function Sprint3PlanHashRunner(): React.JSX.Element {
  const [summary, setSummary] = useState<string>('');
  const [details, setDetails] = useState<string[]>([]);

  useEffect(() => {
    (async () => {
      const cases: Array<{ name: string; ast: LegalBlock[] }> = [
        { name: 'base_paragraph', ast: [{ id: 'p1', type: 'Paragraph', attrs: {}, children: [{ id: 'r1', text: 'Hello world '.repeat(80) }]} as any] },
        { name: 'heading_keep_with_next', ast: [
          { id: 'h1', type: 'Heading', attrs: { level: 2 }, children: [{ id: 'rh', text: 'Section' }] , legalConstraints: { keepWithNext: true }} as any,
          { id: 'p2', type: 'Paragraph', attrs: {}, children: [{ id: 'r2', text: 'Following paragraph '.repeat(60) }]} as any,
        ]},
        { name: 'widows_orphans_split', ast: [{ id: 'p3', type: 'Paragraph', attrs: {}, children: [{ id: 'r3', text: 'A long paragraph to test seam logic. '.repeat(120) }]} as any] },
        { name: 'atomic_at_bottom', ast: [
          { id: 'p4', type: 'Paragraph', attrs: {}, children: [{ id: 'r4', text: 'Filling content. '.repeat(150) }]} as any,
          { id: 'img1', type: 'Image', attrs: { src: '#', width: 400, height: 400 }, legalConstraints: { noSplit: true } } as any,
        ]},
        { name: 'footnotes_overflow', ast: [{ id: 'p5', type: 'Paragraph', attrs: {}, children: [
          { id: 'r5a', text: 'Body with anchors '.repeat(60) },
          { id: 'r5b', text: '', annotations: { footnoteAnchorId: 'fn1' } },
          { id: 'r5c', text: ' more content '.repeat(60) },
          { id: 'r5d', text: '', annotations: { footnoteAnchorId: 'fn2' } },
        ]} as any] },
      ];
      let pass = 0, fail = 0; const lines: string[] = [];
      for (const c of cases) {
        const a = await paginate(c.ast as any, { pageSetup: SETUP });
        const b = await paginate(c.ast as any, { pageSetup: SETUP });
        const ok = a.planHash && a.planHash === b.planHash;
        if (ok) pass++; else fail++;
        lines.push(`${ok ? 'PASS' : 'FAIL'} ${c.name} planHash=${a.planHash}`);
      }
      setSummary(`Summary: PASS=${pass} FAIL=${fail}`);
      setDetails(lines);
    })();
  }, []);

  return (
    <div style={{ padding: 16 }}>
      <h2>EdgeDocs Sprint 3 PlanHash Runner</h2>
      <div style={{ marginBottom: 8 }}>{summary}</div>
      <pre style={{ fontSize: 12, background: '#f8fafc', padding: 8 }}>{details.join('\n')}</pre>
    </div>
  );
}


